import Axios from 'axios';
import ApiUtils from './api-utils';

export default {
  getTiers: (numTiers) => ApiUtils.responseParser(Axios.get('/web/v1/tiers/' + numTiers)),

  getIncidentPaiementTiers: (param) => ApiUtils.responseParser(Axios.get(`/web/v1/tiers/${param.numTiers}/incident-paiement?typeTiers=${param.typeTiers}&numEntite=${param.numEntite}`)),

  searchTiers: (q) => ApiUtils.responseParser(Axios.get('/web/v1/tiers/search?q=' + q))
};
